import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CourseMasterRoutingModule } from './course-master-routing.module';
import { MainpageComponent } from './course-fee/mainpage/mainpage.component';
import { CreateEditPageComponent } from './course-fee/create-edit-page/create-edit-page.component';
import { ConfirmSaveComponent } from './course-fee/confirm-save/confirm-save.component';
import { ConfirmDeleteComponent } from './course-fee/confirm-delete/confirm-delete.component';
import { DeleteComponent } from './course-fee/delete/delete.component';
import { AlertComponent } from './course-fee/alert/alert.component';
import { FinalpopupComponent } from './course-fee/finalpopup/finalpopup.component';
import { FooterComponent } from './course-fee/footer/footer.component';
import { CourseFeeHeaderComponent } from './course-fee/course-fee-header/course-fee-header.component';
import { SavedialogComponent } from './course-fee/savedialog/savedialog.component';
import { FirstPageComponent } from './course-fee/first-page/first-page.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule} from '@angular/material/dialog';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CampusLandingpageComponent } from './campus-Track/campus-landingpage/campus-landingpage.component';
import { LandingPageComponent } from './course-Track/landing-page/landing-page.component';
import { LandingLinksComponent } from './course-Track/landing-links/landing-links.component';
import { CampusLandingLinksComponent } from './campus-Track/campus-landing-links/campus-landing-links.component';
import { CampusTrackComponent } from './campus-Track/campus-track/campus-track.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { CampusdialogComponent } from './campus-Track/campusdialog/campusdialog.component';
import { DialogcampusComponent } from './campus-Track/dialogcampus/dialogcampus.component';
import { DialogComponent } from './course-Track/dialog/dialog.component';
import { CourseTrackComponent } from './course-Track/course-track/course-track.component';
import { MatRadioModule } from '@angular/material/radio';
import { EditdialogComponent } from './course-fee/editdialog/editdialog.component';
import { CreatedialogComponent } from './course-fee/createdialog/createdialog.component';
import { CoursedialogComponent } from './course-Track/coursedialog/coursedialog.component';

@NgModule({
  declarations: [
    MainpageComponent,
    CreateEditPageComponent,
    ConfirmSaveComponent,
    ConfirmDeleteComponent,
    DeleteComponent,
    AlertComponent,
    FinalpopupComponent,
    FooterComponent,
    CourseFeeHeaderComponent,
    SavedialogComponent,
    FirstPageComponent,
    CampusLandingpageComponent,
    LandingPageComponent,
    LandingLinksComponent,
    CampusLandingLinksComponent,
    CampusTrackComponent,
    CampusdialogComponent,
    DialogcampusComponent,
    DialogComponent,
    CourseTrackComponent,
    EditdialogComponent,
    CreatedialogComponent,
    CoursedialogComponent
  ],
  imports: [
    CommonModule,
    CourseMasterRoutingModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    
    FormsModule,ReactiveFormsModule,
    MatDialogModule,
    MatRadioModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    BrowserAnimationsModule,
    AcademicFormModule
  ]
})
export class CourseMasterModule { }
